import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'semantic-ui-react';

import {SCOUT_MANAGEMENT_PLATFORM_STAGE_LINK} from '@constants/variables';

const StageScoutManagementPlatform = ({event}) => {
    const openStageScoutManagementPlatform = () => {
        const openURL = `${SCOUT_MANAGEMENT_PLATFORM_STAGE_LINK}sr:stage:${event.st_event.stage.id}`;
        window.open(openURL, '_blank');
    };

    return (
        <Dropdown.Item
            icon='external alternate'
            key={'openStageScoutManagementPlatform'}
            onClick={openStageScoutManagementPlatform}
            text='Open the stage in Scout Management Platform (SMP)'
        />
    );
};

StageScoutManagementPlatform.propTypes = {
    event: PropTypes.shape({
        st_event: PropTypes.shape({
            stage: PropTypes.shape({
                id: PropTypes.string,
            }),
        }),
    }).isRequired,
};

export default StageScoutManagementPlatform;
